import { createSelector } from "@reduxjs/toolkit";
import { SLICE_NAMES } from "./sliceNames";

export const selectTreatmentId = createSelector(s => s[SLICE_NAMES?.TREATMENT_SERVER_DATA_SLICE]?.serverData?.id, treatmentId => treatmentId);
